import CruiseResultCard from '../components/results/CruiseResultCard';
import SearchResultsLayout from '../components/SearchResultsLayout';
import { SEARCH_BANNERS } from '../data/mockData';

export default function CruiseResultsPage() {
  return (
    <SearchResultsLayout
      type="cruises"
      bannerImage={SEARCH_BANNERS.cruises}
      title="Cruise Search Results"
      summary={(sp) =>
        `${sp.get('port') || 'Port'} → ${sp.get('destination') || 'Region'} · ${sp.get('depart') || 'Flexible'}`
      }
      renderCard={(item, searchParams) => (
        <CruiseResultCard key={item.id} item={item} searchParams={searchParams} />
      )}
    />
  );
}
